export const CALENDAR_VARIANT_EDITOR_PREVIEW = 'editorPreview'

export const isEditorPreviewCalendarVariant = (variant) => (
  variant === CALENDAR_VARIANT_EDITOR_PREVIEW
)
